

// if the formidable phone field exists, add the input mask
const Formidable = (input) => {
  // This code empowers all input tags having a placeholder and data-slots attribute
  // adapted from https://stackoverflow.com/questions/12578507/implement-an-input-with-a-mask
  input.setAttribute('data-inputmask', '\'mask\': \'(999) 999-9999\'');
  input.setAttribute('data-mask', '(999) 999-9999');
  input.setAttribute('maxlength', '18');
  const oldPlaceholder = input.getAttribute('placeholder');
  const pattern = '(___) ___-____';
  const slots = new Set('_'),
  prev = (j => Array.from(pattern, (c,i) => slots.has(c)? j=i+1: j))(0),
  first = [...pattern].findIndex(c => slots.has(c)),
  accept = new RegExp(input.dataset.accept || '\\d', 'g'),
  clean = input => {
    input = input.match(accept) || [];
    return Array.from(pattern, c =>
      input[0] === c || slots.has(c) ? input.shift() || c : c
      );
    },
    format = () => {
      const [i, j] = [input.selectionStart, input.selectionEnd].map(i => {
          i = clean(input.value.slice(0, i)).findIndex(c => slots.has(c));
          return i<0? prev[prev.length-1]: back? prev[i-1] || first: i;
      });
      input.value = clean(input.value).join``;
      input.setSelectionRange(i, j);
      back = false;
    },
    setPlaceholder = () => input.setAttribute('placeholder', pattern),
    restorePlaceholder = () => {
      if (!/\d/.test(input.value)) {
        input.value='';
        input.setAttribute('placeholder', oldPlaceholder);
      }
    };
  let back = false;
  input.addEventListener('keydown', (e) => back = e.key === 'Backspace');
  input.addEventListener('input', format);
  input.addEventListener('focus', setPlaceholder);
  input.addEventListener('blur', restorePlaceholder);
};

export default Formidable;
